import withAuthentication from '@hocs/withAuthentication';
import { Order } from '@screens/Order';
import { useRouter } from 'next/router';
import { NextSeo } from 'next-seo';
import getConfig from 'next/config';
import LayoutAccount from '@components/LayoutAccount';
import { IMenuAccount } from '@monofront/types';
import { prismicService } from '@services/businessContainer';
import { GetStaticProps } from 'next';
import { PrismicDocument } from '@prismicio/client';
import { useTranslations } from 'next-intl';
import { LFPage, injectLayoutData } from '@utils/layout';

const {
  publicRuntimeConfig: { appBaseUrl },
} = getConfig();

export const PageOrder: LFPage<IMenuAccount> = ({ menuAccount }) => {
  const router = useRouter();
  const tAccount = useTranslations('Account');
  const urlPath = router.asPath.split('?')[0];

  return (
    <>
      <NextSeo
        title={`${tAccount('order')} #${router.query.id}`}
        canonical={`${appBaseUrl}${urlPath}`}
        openGraph={{
          url: `${appBaseUrl}${urlPath}`,
          title: `${tAccount('order')} #${router.query.id}`,
        }}
      />
      <LayoutAccount
        hasDesktopSideMenu
        menu={menuAccount}
        breadcrumbParent={{
          href: '/account/orders',
          label: tAccount('myOrders'),
        }}
      >
        <Order id={router.query.id as string} />
      </LayoutAccount>
    </>
  );
};

export default withAuthentication(PageOrder);

export const getStaticPaths = async () => {
  return {
    paths: [],
    fallback: 'blocking',
  };
};

export const getStaticProps = injectLayoutData<
  IMenuAccount,
  GetStaticProps<IMenuAccount>
>(async ({ previewData, locale }) => {
  const menu: PrismicDocument = await prismicService.getDocumentByUid(
    'shopaccount',
    'shopaccount',
    previewData,
    locale ? { lang: `${locale}-${locale}` } : {},
  );

  if (!menu) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      menuAccount: menu.data.body,
    },
    revalidate: 1800, // 30min
  };
});
